module.exports = __webpack_public_path__ + "img/video-id-image.d15d313a.svg";